import { GET_SCHEDULE, GET_SCHEDULE_FACULTIES, GET_SCHEDULE_SECTIONS, GET_SCHEDULE_STUDENTS, GET_SCHEDULE_SUBJECTS, GET_SCHEDULE_CLASS_AND_AFFILIATION, GET_CLASS_SCHEDULES, GET_CLASS_STUDENTS, MARK_ABSENT, MARK_PRESENT, MARK_INDIVIDUAL, CHANGE_LEAVE_STATUS, GET_ATTENDANCE_FACULTY_LIST, RESET_CLASS_AND_AFFILIATION, GET_STUDENT_SCHEDULE, GET_STUDENT_FACULTY_LIST, GET_STUDENT_SUBJECT_LIST, RESET_STUDENTS_AND_SECTIONS } from "../Types/types";

let intialState = {
    subjects: [],
    faculties: [],
    sections: [],
    students: [],
    schedules: [],
    isStudentScheduleLoading: true,
    isListLoading: true
}

export default function scheduleReducer(state = intialState, action) {
    let stateCopy = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case GET_SCHEDULE:
            stateCopy.scheduleList = action.payload.data;
            stateCopy.isListLoading = false;
            stateCopy.schedulePagination = action.payload.pagination;
            return stateCopy;
        case GET_SCHEDULE_FACULTIES:
            stateCopy.faculties = action.payload.map(faculty => ({
                value: faculty._id,
                label: faculty.firstname + ' ' + faculty.lastname
            }));
            return stateCopy;
        case GET_SCHEDULE_SECTIONS:
            stateCopy.sectionsList = action.payload.map(section => ({
                value: section._id,
                label: section.name
            }));
            return stateCopy;
        case GET_SCHEDULE_STUDENTS:
            stateCopy.studentsList = action.payload.map(student => ({
                value: student._id,
                label: student.firstname + ' ' + student.lastname
            }));
            return stateCopy;
        case GET_SCHEDULE_SUBJECTS:
            stateCopy.subjectList = action.payload.map(subject => ({
                value: subject._id,
                label: subject.name
            }));
            return stateCopy;
        case GET_SCHEDULE_CLASS_AND_AFFILIATION:
            stateCopy.classAndAffiliation = action.payload;
            return stateCopy;
        case RESET_CLASS_AND_AFFILIATION:
            stateCopy.classAndAffiliation = null;
            return stateCopy;
        case RESET_STUDENTS_AND_SECTIONS:
            stateCopy.sectionsList = [];
            stateCopy.studentsList = [];
            return stateCopy;
        case "Select_All_Classes":
            if (action.payload) {
                stateCopy.scheduleList.forEach(el => {
                    el.isChecked = true
                })
            }
            else {
                stateCopy.scheduleList.forEach(el => {
                    el.isChecked = false
                })
            }
            return stateCopy;
        case "Select_One_Class":
            if (action.payload.checked) {
                stateCopy.scheduleList.forEach(el => {
                    if (el._id === action.payload.id) {
                        el.isChecked = true
                    }
                })
            }
            else {
                stateCopy.scheduleList.forEach(el => {
                    if (el._id === action.payload.id) {
                        el.isChecked = false
                    }
                })
            }
            return stateCopy;
        case GET_CLASS_SCHEDULES:
            stateCopy.classSchedules = action.payload.data;
            stateCopy.classSchedulePagination = action.payload.pagination;
            return stateCopy;
        case GET_ATTENDANCE_FACULTY_LIST:
            stateCopy.facultyList = action.payload;
            return stateCopy;
        case GET_CLASS_STUDENTS:
            stateCopy.classStudents = action.payload;
            stateCopy.present = stateCopy.classStudents.filter(el => el.present).length;
            return stateCopy;
        case MARK_PRESENT:
            stateCopy.classStudents.forEach(element => {
                element.present = true
            });
            stateCopy.present = stateCopy.classStudents.filter(el => el.present).length;
            return stateCopy;
        case MARK_ABSENT:
            stateCopy.classStudents.forEach(element => {
                element.present = false
            });
            stateCopy.present = stateCopy.classStudents.filter(el => el.present).length;
            return stateCopy;
        case MARK_INDIVIDUAL:
            stateCopy.classStudents.forEach(el => {
                if (el._id === action.payload.id) {
                    el.present = el.present ? false : true
                    el.leave = el.present && null
                }
            })
            stateCopy.present = stateCopy.classStudents.filter(el => el.present).length;
        case CHANGE_LEAVE_STATUS:
            stateCopy.classStudents.forEach(el => {
                if (el.student_id === action.payload.id) {
                    el.leave = action.payload.val
                }
            })
        case GET_STUDENT_SCHEDULE:
            stateCopy.studentScheduleList = action.payload.data;
            stateCopy.isStudentScheduleLoading = false;
            stateCopy.studentSchedulePagination = action.payload.pagination;
            return stateCopy;
        case GET_STUDENT_SUBJECT_LIST:
            stateCopy.studentSubjectList = action.payload.map(el => [{ value: el._id, label: el.name}][0]);
            return stateCopy;
        case GET_STUDENT_FACULTY_LIST:
            stateCopy.studentFacultyList = action.payload.map(el => [{ value: el._id, label: el.firstname + ' ' + el.lastname}][0]);
            return stateCopy;
        default:
            return stateCopy;
    }
}